import { render, staticRenderFns } from "./LoadGeotiffControl.vue?vue&type=template&id=2b7484d9&scoped=true&lang=pug"
import script from "./LoadGeotiffControl.vue?vue&type=script&lang=js"
export * from "./LoadGeotiffControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7484d9",
  null
  
)

export default component.exports